import { ALL_WORKGROUP_DEFAULT_FILTERS } from "../constants";
import { ONE_YEAR_FROM, YESTERDAY } from "../dateHelper";
import { BID_DATE_TYPE, BID_STATUS, BID_TYPE, EMPLOYEE_BID_DATE_TYPE, EMPLOYEE_BID_STATUS } from "./bidConstants";

export const DEFAULT_ADMIN_BID_DATE_TYPE = BID_DATE_TYPE.BID_EFFECTIVE_DATE;
export const DEFAULT_ADMIN_BID_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};
export const DEFAULT_ADMIN_BID_END_DATE_FILTER = (station) => {
  return ONE_YEAR_FROM(station, YESTERDAY(station));
};
export const DEFAULT_ADMIN_BID_TYPE_FILTERS = [BID_TYPE.SHIFT, BID_TYPE.FREEDAY];
export const DEFAULT_ADMIN_BID_STATUS_FILTERS = [
  BID_STATUS.AWARDED,
  BID_STATUS.CLOSED,
  BID_STATUS.OPEN,
  BID_STATUS.PENDING,
  BID_STATUS.WITHDRAWN,
];
export const DEFAULT_EMPLOYEE_BID_DATE_TYPE = EMPLOYEE_BID_DATE_TYPE.BID_EFFECTIVE_DATE;
export const DEFAULT_EMPLOYEE_BID_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};
export const DEFAULT_EMPLOYEE_BID_END_DATE_FILTER = (station) => {
  return ONE_YEAR_FROM(station, YESTERDAY(station));
};
export const DEFAULT_EMPLOYEE_BID_TYPE_FILTERS = [BID_TYPE.SHIFT, BID_TYPE.FREEDAY];
export const DEFAULT_EMPLOYEE_BID_STATUS_FILTERS = [
  EMPLOYEE_BID_STATUS.AWARDED,
  EMPLOYEE_BID_STATUS.CLOSED,
  EMPLOYEE_BID_STATUS.OPEN,
  EMPLOYEE_BID_STATUS.WITHDRAWN,
];
export const DEFAULT_EMPLOYEE_BID_WORKGROUP_FILTERS = ALL_WORKGROUP_DEFAULT_FILTERS;

export const DEFAULT_BID_SORT_MODEL = [
  {
    field: "windowDates",
    sort: "asc",
  },
];

export const DEFAULT_EMPLOYEE_BID_SORT_MODEL = [
  {
    field: "status",
    sort: "asc",
  },
];

export function filterBids(
  bids,
  dateTypeFilter,
  startDateFilter,
  endDateFilter,
  bidTypeFilters,
  statusFilters,
  workgroupFilters,
  isAdminPage
) {
  let filteredBids = bids;
  filteredBids = filterOnDateType(filteredBids, dateTypeFilter, startDateFilter, endDateFilter);
  filteredBids = filterOnBidTypes(filteredBids, bidTypeFilters);
  filteredBids = filterOnStatuses(filteredBids, statusFilters, isAdminPage);
  filteredBids = filterOnWorkgroups(filteredBids, workgroupFilters);
  return filteredBids;
}

export function filterOnDateType(filteredBids, dateTypeFilter, startDateFilter, endDateFilter) {
  if (dateTypeFilter) {
    if (dateTypeFilter === BID_DATE_TYPE.LAST_UPDATED_DATE) {
      filteredBids = filteredBids.filter(
        (bid) =>
          bid.createdAt.toMillis() >= startDateFilter.toMillis() && bid.createdAt.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === BID_DATE_TYPE.BID_WINDOW_DATE) {
      filteredBids = filteredBids.filter(
        (bid) =>
          bid.windowEndDate?.toMillis() >= startDateFilter.toMillis() &&
          bid.windowStartDate?.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === BID_DATE_TYPE.BID_EFFECTIVE_DATE) {
      filteredBids = filteredBids.filter(
        (bid) =>
          bid.schedEndDate?.toMillis() >= startDateFilter.toMillis() &&
          bid.schedStartDate?.toMillis() <= endDateFilter.toMillis()
      );
    }
  }
  return filteredBids;
}

export function filterOnBidTypes(filteredBids, bidTypeFilters) {
  if (bidTypeFilters) {
    filteredBids = filteredBids.filter((bid) => bidTypeFilters.includes(bid.bidType));
  }
  return filteredBids;
}

export function filterOnStatuses(filteredBids, statusFilters) {
  if (statusFilters) {
    filteredBids = filteredBids.filter((bid) => statusFilters.includes(bid.status));
  }
  return filteredBids;
}

export function filterOnWorkgroups(filteredBids, workgroupFilters) {
  if (workgroupFilters) {
    filteredBids = filteredBids.filter((bid) => workgroupFilters.includes(bid.workgroup));
  }
  return filteredBids;
}

export function filterBidsOnInfoFilter(filteredBids, bidInfoFilter) {
  if (bidInfoFilter) {
    filteredBids = filteredBids.filter(
      (bid) =>
        bid.status === bidInfoFilter || (bid.status === BID_STATUS.PENDING && bid.scheduledStatus === bidInfoFilter)
    );
  }
  return filteredBids;
}

export function filterDeletedBidChoiceEvents(bidChoiceEvents) {
  const filteredBids = bidChoiceEvents.filter((event) => event.updateType !== "DELETE");
  return filteredBids;
}

export function filterAndSortSelectedBidLines(bidLines, selectedChoices) {
  const selectedBidLines = bidLines.filter((obj) => selectedChoices?.some((element) => obj.id === element));
  const sortedBidLines = selectedBidLines.sort((a, b) => {
    const indexA = selectedChoices.indexOf(a.id);
    const indexB = selectedChoices.indexOf(b.id);
    return indexA - indexB;
  });
  sortedBidLines.map((item, index) => (item.choice = index + 1));
  return sortedBidLines;
}
